import React from 'react';
import CourseDetailTemplate from '../components/course/CourseDetailTemplate';
import { coursesData } from '../data/coursesData';
const Course1Page = () => {
  return <CourseDetailTemplate courseData={coursesData[1]} data-id="element-2339" />;
};
export default Course1Page;